// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kind-saltyscore-container {
  margin-bottom: 2rem;
}

.feedback {
  margin-bottom: 1rem;
}

.feedback.success {
  color: var(--dunkelgruen);
}

.feedback.error {
  color: var(--blutorange);
}

.form-group {
  margin-bottom: 1rem;
  text-align: left;
}

.saltyscore-form input[type="number"] {
  background-color: rgba(180, 200, 130, 0.5);
  border: none;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  color: gray;
  margin-bottom: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/arbeit/kind_saltyscore/KindSaltyScore.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".kind-saltyscore-container {\n  margin-bottom: 2rem;\n}\n\n.feedback {\n  margin-bottom: 1rem;\n}\n\n.feedback.success {\n  color: var(--dunkelgruen);\n}\n\n.feedback.error {\n  color: var(--blutorange);\n}\n\n.form-group {\n  margin-bottom: 1rem;\n  text-align: left;\n}\n\n.saltyscore-form input[type=\"number\"] {\n  background-color: rgba(180, 200, 130, 0.5);\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  width: 100%;\n  color: gray;\n  margin-bottom: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
